import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { ApiClient } from '../api-client/api-client';
import { SleekNoteMessage } from 'src/app/model/interfaces/sleeknote-message';
import { SleeknoteData } from '../data/sleeknotes.data';

@Injectable()
export class PopupRepository
{
    private readonly apiClient: ApiClient;
    private sleeknotesFromBackend: SleekNoteMessage[] = SleeknoteData;
    
    public constructor(apiClient: ApiClient)
    {
        this.apiClient = apiClient;
    }

    public getPopupMessage(): Observable<SleekNoteMessage[]>
    {
        if (this.sleeknotesFromBackend && this.sleeknotesFromBackend.length > 0)
        {
            this.filterCurrentNotes();
        }
        
        return of(this.sleeknotesFromBackend);
    }

    public filterCurrentNotes(): void 
    {
        this.sleeknotesFromBackend = this.sleeknotesFromBackend.filter( (message) => {
          
            const nowDate = new Date();
            
            if (message.StartDate.getTime() < nowDate.getTime() && message.EndDate.getTime() > nowDate.getTime())
            {
                return true;
            }
            else 
            {
                return false;
            }
        });
    }
}